export default {
    SERVER_BASE_URL: 'https://api.proof.nonprod.wemlo.io/',
    PHONE_EXT:'+1',
    ENV: 'proof',
    CLIENT_URL:'https://app.proof.nonprod.wemlo.io/',
    OPTIMIZELY_KEY: 'WFHQHSxhfWTwBraRL7QoC',
}
